// 订购服务
import {post} from './http';
const baseUrl = '/api/admin/module';

// 查询版本服务
export const getServiceshopmoduleList = v => post(`${baseUrl}/getServiceshopmoduleList`,v.data,v.success,v.error)

// 查询功能服务
export const getFunctionshopmoduleList = v => post(`${baseUrl}/getFunctionshopmoduleList`,v.data,v.success,v.error)

// 订购记录列表
export const getShopmoduleorderinfoList = v => post(`${baseUrl}/getShopmoduleorderinfoList`,v.data,v.success,v.error)

// 订购提交订单
export const savePriceBuyInfo = v => post(`${baseUrl}/savePriceBuyInfo`,v.data,v.success,v.error)

// 获取支付结果信息
export const queryOrderPayResult = v => post(`${baseUrl}/queryOrderPayResult`,v.data,v.success,v.error)

// 查询订购详情
export const getShopmoduleorderinfo = v => post(`${baseUrl}/getShopmoduleorderinfo`,v.data,v.success,v.error)

// 订购订单取消
export const cancelPriceAssOrder = v => post(`${baseUrl}/cancelPriceAssOrder`,v.data,v.success,v.error)

// 根据订单号获取支付Url
export const getOrderPayUrl = v => post(`${baseUrl}/getOrderPayUrl`,v.data,v.success,v.error)

// 获取确认订单信息
export const getShopmoduleBuyInfo = v => post(`${baseUrl}/getShopmoduleBuyInfo`,v.data,v.success,v.error)

// 提交订单并支付
export const uploadModuleBuyOrder = v => post(`${baseUrl}/uploadModuleBuyOrder`,v.data,v.success,v.error)
